import Chevron from 'src/components/dashboard/components/navigationMenu/components/chevron';
import { formatDate } from 'src/utils/formatDate';
import { FundingStatusTableData } from 'src/services/models/funding.service';
import { useLocalization } from 'src/utils/useLocalization';
import { Dispatch, SetStateAction } from 'react';
import { StatusDot, statusToStatusClass } from '../ui/statusDot';

import './style.scss';

export interface ITableContents {
    items: FundingStatusTableData[];
    setFundingDetail: Dispatch<SetStateAction<number>>;
}

export interface FundingStatusTableItemData {
    data: FundingStatusTableData;
    setFundingDetail: Dispatch<SetStateAction<number>>;
}

export const TableItem: React.FC<FundingStatusTableItemData> = ({
    data,
    setFundingDetail,
}) => {
    const { name, accountNumber, status, vin, dateReceived } = data;
    const statusCSSClassName = statusToStatusClass(status);
    const { statusFilterResponseToOptionMap, fundingStatus } =
        useLocalization();
    return (
        <div className='row'>
            <div className='table-row col-1'>
                <span className='list-label'>
                    {fundingStatus.TABLE_HEADER_NAME}
                </span>
                <span
                    className='underline'
                    onClick={() => setFundingDetail(accountNumber)}
                >
                    {name}
                </span>
            </div>
            <div className='table-row col-2'>
                <span className='list-label'>
                    {fundingStatus.TABLE_HEADER_ACCOUNT_NUMBER}
                </span>
                <span>{accountNumber}</span>
            </div>
            <div className='table-row col-3'>
                <span className='list-label'>
                    {fundingStatus.TABLE_HEADER_STATUS}
                </span>
                <div className='status'>
                    <StatusDot color={statusCSSClassName} />
                    <span className='dot-label'>
                        {statusFilterResponseToOptionMap[status]}
                    </span>
                </div>
            </div>
            <div className='table-row funding-table-col-4'>
                <span className='list-label'>
                    {fundingStatus.TABLE_HEADER_VIN}
                </span>
                {vin}
            </div>
            <div className='table-row col-5'>
                <span className='list-label'>
                    {fundingStatus.TABLE_HEADER_DATE}
                </span>
                <span>{formatDate(dateReceived)}</span>
            </div>
        </div>
    );
};

export const Table: React.FC<ITableContents> = ({
    items,
    setFundingDetail,
}) => {
    const chevronColor = '#363b49';
    const { fundingStatus } = useLocalization();
    return (
        <div className='table'>
            <div className='row header-row hidden-in-list'>
                <div className='table-header col-1'>
                    <span className='u-text-truncate'>
                        {fundingStatus.TABLE_HEADER_APPLICANT_NAME}
                    </span>
                    <span>
                        <Chevron
                            className='accordion__icon rotate-down'
                            width={10}
                            fill={chevronColor}
                        />
                    </span>
                </div>
                <div className='table-header col-2'>
                    <span className='u-text-truncate'>
                        {fundingStatus.TABLE_HEADER_ACCOUNT_NUMBER}
                    </span>
                    <span>
                        <Chevron
                            className='accordion__icon rotate-down'
                            width={10}
                            fill={chevronColor}
                        />
                    </span>
                </div>
                <div className='table-header col-3'>
                    <span className='u-text-truncate'>
                        {fundingStatus.TABLE_HEADER_STATUS}
                    </span>
                    <span>
                        <Chevron
                            className='accordion__icon rotate-down'
                            width={10}
                            fill={chevronColor}
                        />
                    </span>
                </div>
                <div className='table-header col-4'>
                    <span className='u-text-truncate'>
                        {fundingStatus.TABLE_HEADER_VIN}
                    </span>
                    <span>
                        <Chevron
                            className='accordion__icon rotate-down'
                            width={10}
                            fill={chevronColor}
                        />
                    </span>
                </div>
                <div className='table-header col-5'>
                    <span className='u-text-truncate'>
                        {fundingStatus.TABLE_HEADER_DATE}
                    </span>
                    <span>
                        <Chevron
                            className='accordion__icon rotate-down'
                            width={10}
                            fill={chevronColor}
                        />
                    </span>
                </div>
            </div>
            {items.map((item) => (
                <TableItem
                    data={item}
                    key={item.key}
                    setFundingDetail={setFundingDetail}
                />
            ))}
        </div>
    );
};

export default Table;
